<script lang="ts" setup>
import AUApi from "@/api";
import {
  getDateFromInput,
  getMask,
  valueToFormatStr,
  highlightDays,
} from "./CalenderHelper";

// import { RenderDayCellEventArgs } from "@syncfusion/ej2-vue-calendars";
import { findSperrDate } from "@/SperreHelper";

import {
  ref,
  useTemplateRef,
  onMounted,
  reactive,
  getCurrentInstance,
} from "vue";
import {
  CommonEditControlEmits,
  EditControlProps,
  getDefaultEditorControlConfig,
  mounted,
  valueChanged,
  setValueOnEditPageData,
} from "@/editor/EditComponentStatic";
import MaskedInput from "./MaskedInput.vue";
import { useRegisterValidation } from "@/components/EditorValidator";
declare interface EditDatePickerControlProps extends EditControlProps {
  formatProp?: string;
  onFocus?: boolean;
  queryZeitbereich?: APIZeitbereich;
  noMessages?: boolean; // wenn true: keine Fehlermeldungen/Hinweise anzeigen
}

declare interface EditDatePickerUiData extends EditorControlUiData {
  menuLeft: number; // = 0;
  menuTop: number; // = 0;
  showPicker: boolean; // = false;
  showField: boolean; // = true;
  inputText: string; // = "";
  mask: string; // = "D1.M1.1111";
  inputDate: Date; // = ""
  format1: string; // = "dd.MM.yyyy"; // übergabe Format und ANZEIGE Format Muss ident sein!
  format: string; // = "dd.MM.yyyy";
  inputFormat: string; // = null; // auf maske abgestimmter formatstr
  strict: boolean; // = true;
  start: string; // = "Month";
  depth: string; // = "Year";
  showLabel: boolean; // = false;
  initalized: boolean; // = false;
  iconCss?: string;

  // Datum für Picker
  currentDate?: string; // string des datums
  currentDateValue?: Date; // das echte datum

  minDate?: Date; // = ""; // auf SperrDAtum setzen
  maxDate?: Date; // = "";
  holidayDate: Holiday[]; // = []; // muss mit den Datums aus der Holiday tabelle gefüllt werden
  isFocused?: boolean;
  //errorMessages: Array<string> = [];
  text?: string;
  sperrBegriff?: string;
}

const props = defineProps<EditDatePickerControlProps>();
const emitFn = defineEmits<CommonEditControlEmits>();

const { config, ui } = getDefaultEditorControlConfig<
  EditorControlConfig,
  EditDatePickerControlProps,
  EditDatePickerUiData
>(props, emitFn, {
  // default start values
  menuLeft: 0,
  menuTop: 0,
  showPicker: false,
  showField: true,
  mask: "D1.M1.1111",
  format1: "dd.MM.yyyy", // übergabe Format und ANZEIGE Format Muss ident sein!
  format: "dd.MM.yyyy",
  strict: true,
  start: "Month",
  depth: "Year",
  showLabel: false,
  initalized: false,

  holidayDate: [], // muss mit den Datums aus der Holiday tabelle gefüllt werden
  errorMessages: [],
});
config.validate = validate;
useRegisterValidation({ config });

const uiData = reactive(ui);
const maskedControl = useTemplateRef("masked");
// Eindeutige ID pro Komponente, damit der v-menu-Activator korrekt ist
const activatorId = `edp-${
  getCurrentInstance()?.uid ?? Math.random().toString(36).slice(2)
}`;
onMounted(async () => {
  mounted(uiData, props, config);
  await mountedBaseDatePicker();
});

function disabledText() {
  //      return this.valueToFormatStr(this.currentDate, uiData.format);
  if (uiData.currentDateValue) {
    return valueToFormatStr(uiData.currentDateValue, uiData.format);
  } else {
    return valueToFormatStr(uiData.data, uiData.format);
  }
}

async function mountedBaseDatePicker() {
  //this.mountedBase();
  const sperrDate = getSperrDate(uiData.sperrBegriff);
  if (sperrDate) {
    uiData.minDate = new Date(sperrDate);
  }
  if (props.formatProp) {
    uiData.format = props.formatProp;
  }
  if (props.queryZeitbereich) {
    const bis = props.queryZeitbereich.bis;
    uiData.maxDate = bis;
    const min = props.queryZeitbereich.von;
    uiData.minDate = min;
  } else {
    // es darf kein Datum in die ZUKUNFT erfasst werden..
    // beim Stamm - Datum soll es aber möglich sein ( zB Wunscheintritt für Bewerber)
    if (config.column?.datatype !== "Datum") {
      uiData.maxDate = new Date();
    }
  }
  if (config.column?.meta.zukunft || config.column === undefined) {
    // wenn es ein frei definiertes datum ist - dann auch nicht sperren
    uiData.maxDate = undefined;
  }
  if (
    config.column?.datatype === "Eintritt" ||
    config.column?.datatype === "Austritt" ||
    config.column?.datatype === "Stichtag"
  ) {
    const bis = AUApi.Current.zeitbereich.bis;
    uiData.maxDate = bis;
  }
  // Geburtsdatum: ältere Daten zulassen (z.B. ab 1900)
  if (config.column?.datatype && /geburt/i.test(config.column.datatype)) {
    uiData.minDate = new Date(1900, 0, 1);
  }
  if (config.column?.meta?.format) {
    uiData.format = config.column.meta.format;
    if (uiData.format === "MM.yyyy") {
      uiData.start = "Year";
      uiData.depth = "Year";

      // uiData.format1 = uiData.format.replace(/(EE)/g, "");
    } else if (uiData.format === "HH:mm") {
      // auf TimerPicker umstellen!
    }
  }
  let date: any = null;
  const initValue = config.initValue;
  if (!uiData.disabled || uiData.required || !config.column?.meta?.invisible) {
    if (initValue) {
      if (typeof initValue === "string") {
        // wenn string dan hoffentlich ein iso
        date = new Date(initValue);
        if (isNaN(date)) {
          // ungültige ignorieren wir ;)
          date = null;
        }
      } else if (
        // schaun obs ein gültiges datum is
        Object.prototype.toString.call(date) === "[object Date]" &&
        !isNaN(date)
      ) {
        date = initValue;
      }
    } else if (config.column) {
      if (config.column.meta.neuArt && config.column.meta.neuArt === "Sync") {
        // Datum auf VON EditZeitbereich setzen....???
        date = new Date().toISOStringWithTZ();
      } else if (config.column.meta.auto && initValue === undefined) {
        // Datum auf VON EditZeitbereich setzen....
        date = new Date().toISOStringWithTZ();
      } else {
        date = initValue;
      }
      date = initValue;
    }

    if (config.column && config.column.meta && config.column.meta.format) {
      uiData.format = config.column.meta.format;
      if (uiData.currentDate === null) {
        uiData.format = uiData.format.replace(/(EE)/g, "");
      }
    }
  }

  // Fallback: wenn kein initValue aus Column vorhanden, nutze externes v-model
  if (!date && props.modelValue) {
    try {
      if (typeof props.modelValue === "string") {
        const d = new Date(props.modelValue);
        if (!isNaN(d as unknown as number)) {
          date = d;
        }
      } else if (
        Object.prototype.toString.call(props.modelValue) === "[object Date]" &&
        !isNaN((props.modelValue as unknown as Date).getTime())
      ) {
        date = props.modelValue as unknown as Date;
      }
    } catch (e) {
      console.warn(
        "EditDatePicker: modelValue konnte nicht als Datum interpretiert werden.",
        e,
      );
    }
  }
  uiData.mask = getMask(uiData.format);
  // Maskierung ermittlen und Wert passend formatieren...
  // Falls Pflichtfeld und deaktiviert: heutigen Tag vorbelegen und für Save setzen
  if (!date && uiData.required && uiData.disabled) {
    const today = new Date();
    const val = toSendValue(today);
    uiData.currentDateValue = today;
    uiData.inputText = uiData.currentDate = valueToFormatStr(
      today,
      uiData.format,
    );
    uiData.data = val;
    uiData.showLabel = true;
    validate();
    // Für Speichern vorbereiten, aber nicht als geändert markieren
    config.initValue = val;
    setValueOnEditPageData(config, uiData, val, true);
    uiData.isChanged = false;
    date = today; // für konsistente Anzeige unten
  }

  if (date) {
    uiData.showLabel = true;
    uiData.currentDateValue = date;
    uiData.inputText = uiData.currentDate = valueToFormatStr(
      date,
      uiData.format,
    );
  } else {
    uiData.currentDateValue = undefined;
    uiData.currentDate = "";
  }
}
function functionEvents(date: string) {
  if (date) {
    const dateLocal = new Date(date);
    const holiday = AUApi.Current.isHoliday(dateLocal);
    if (holiday) {
      return ["red"];
    } else {
      return false;
    }
  }
  return false;
}
function datePicked(value: Date) {
  try {
    uiData.currentDateValue = value;
    uiData.currentDate = valueToFormatStr(value, uiData.format);
    uiData.showPicker = false;
    uiData.inputText = uiData.currentDate;
    uiData.data = toSendValue(new Date(value));
    validate();
    valueChanged(config, uiData, uiData.data);
  } catch (err) {
    console.error(err);
  }
}

// Wert für Speichern/Übergabe: wie in vuefu voller Zeitstempel "yyyy-MM-ddT00:00:00+02:00"
// (sonst rechnet z.B. die Tab-Übergabe im ModellDialog nicht). Nur bei Eintritt das reine
// Datum "yyyy-MM-dd" - seit 9f59af2b (Bewerber Dokumente)
function toSendValue(date: Date): string {
  const iso = date.toISOStringWithTZ();
  return config.column?.datatype === "Eintritt" ? iso.slice(0, 10) : iso;
}
function dateChanged(d: { event: Event; element: HTMLElement }) {
  if (uiData.currentDate !== null) {
    uiData.showLabel = true;
  } else {
    uiData.showLabel = false;
  }
  try {
    if (d && d.event && d.event.type === "blur") {
      return;
    }

    let val: string = "";

    if (!uiData.inputText) {
      uiData.currentDateValue = undefined;
    } else if (typeof uiData.inputText === "string") {
      uiData.currentDateValue = getDateFromInputUI(
        uiData.inputText,
        uiData.format,
      );
    } else if (
      typeof uiData.currentDate === "object" &&
      uiData.currentDateValue?.toISOStringWithTZ
    ) {
      uiData.currentDateValue = uiData.currentDate;
    }

    if (uiData.currentDateValue) {
      val = toSendValue(uiData.currentDateValue);
    }
    validate();

    // uiData.currentDate = val;
    valueChanged(config, uiData, val);
  } catch (err) {
    console.error(err);
  }
}

function validate() {
  try {
    if (uiData.readonly) {
      uiData.errorText = "";
      return true;
    } // disabled Controls sind IMMER valide ;)
    if (uiData.required) {
      let mydate: any = uiData.currentDateValue;
      console.log(mydate);
      if (typeof mydate === "string") {
        const result = getDateFromInput(mydate, uiData.format);

        // getDateFromInput gibt { date: Date, error: string } zurück
        if (result.error) {
          uiData.errorText = result.error;
          return false;
        }

        mydate = result.date;
      }
      if (mydate instanceof Date && !isNaN(mydate.getTime())) {
        uiData.errorText = "";
        return true;
      }
      uiData.errorText = config.requiredMessage;
      return false;
    }

    uiData.errorText = "";
    return true;
  } catch (err) {
    console.error(err);
  }
  return false;
}

function getDateFromInputUI(input: string, format: string): Date | undefined {
  uiData.errorText = "";
  if (!input && uiData.required) {
    uiData.errorText = config.requiredMessage;
    return undefined;
  }

  const res = getDateFromInput(input, format);
  if (res.error) {
    uiData.errorText = res.error;
  } else {
    uiData.errorText = "";
  }
  return res.date;
}

function getSperrDate(begriff: any) {
  const aic = AUApi.Current.user.aic;
  if (props.query) {
    const t = findSperrDate(props.query, aic);
    if (t) {
      const sperrDate = t.sperrDate;
      return new Date(sperrDate);
    }
  }
}

function clickAppend() {
  uiData.showPicker = !uiData.showPicker;
}
</script>
<template>
  <div v-if="uiData.showMutable" class="wrap">
    <v-tooltip
      :disabled="!uiData.showtooltip || !uiData.tooltip"
      location="bottom"
      max-width="300px"
      :text="uiData.tooltip"
    >
      <template v-slot:activator="{ props: tooltipActivatorProps }">
        <MaskedInput
          v-bind="tooltipActivatorProps"
          ref="masked"
          :required="uiData.required"
          :label="uiData.description || description"
          :placeholder="uiData.format"
          :mask="uiData.mask"
          v-model="uiData.inputText"
          @update:modelValue="dateChanged"
          @change="dateChanged"
          @appendClick="clickAppend"
          :errorText="props.noMessages ? undefined : uiData.errorText"
          :id="activatorId"
          v-if="uiData.showField"
          :disabled="uiData.disabled"
          :append-inner-icon="uiData.disabled ? undefined : 'mdi-calendar'"
          append-sync-icon="mdi-clock-outline"
          :autofocus="autofocus"
          :hide-details="props.noMessages === true"
          :persistent-hint="props.noMessages ? false : undefined"
        />

        <v-menu
          v-model="uiData.showPicker"
          :close-on-content-click="false"
          :activator="`#${activatorId}`"
          :disabled="uiData.disabled"
          location="bottom start"
        >
          <v-card variant="outlined" color="warning">
            <v-date-picker
              locale="de"
              v-model="uiData.currentDateValue"
              :min="uiData.minDate"
              :max="uiData.maxDate"
              first-day-of-week="1"
              :show-week="true"
              @update:model-value="datePicked"
              :events="functionEvents"
            ></v-date-picker>
          </v-card>
        </v-menu>
        <ValueChangeTracker
          v-if="
            (uiData.isChanged || props.disableValueChangeTracker) &&
            !props.noMessages
          "
        />
      </template>
    </v-tooltip>
  </div>
</template>
<style scoped>
.rotateIcon {
  translate: rotate(180deg);
  transition: all 0.3s ease;
}

label.e-float-text,
.e-float-input label.e-float-text,
.e-float-input.e-control-wrapper label.e-float-text,
.e-float-input:not(.e-input-focus)
  input:not(:focus):valid
  ~ label.e-float-text.e-label-bottom,
.e-float-input.e-control-wrapper:not(.e-input-focus)
  input:not(:focus):valid
  ~ label.e-float-text.e-label-bottom {
  top: -20px;
}

.e-input-group input.e-input,
.e-input-group.e-control-wrapper input.e-input {
  font-size: 13px;
  font-family: "Roboto", sans-serif;
  padding-bottom: 0px;
}
</style>
